export default "__VITE_PUBLIC_ASSET__e9e08fa0__"